import type { IntlShape } from "react-intl";

export function permissionLabel(intl: IntlShape, code: string, fallback: string): string {
  const id = `admin.permission.${code.replace(/:/g, ".")}`;
  return id in intl.messages ? intl.formatMessage({ id }) : fallback;
}
